import React from 'react';
import { SAVING_OVERLAY_CLASS } from 'utils/mousetrap-react';
import './styles.scss';
import { t } from 'utils/i18n';
import { useReferencesContext } from './references-context';

// a reload ends every find: edits made meanwhile would be dropped, so input is blocked
export default function ReferencesBusyOverlay(): JSX.Element | null {
    const references = useReferencesContext();
    if (!references?.finding) return null;
    const { done, total } = references.finding;
    return (
        <div className={`${SAVING_OVERLAY_CLASS} cvat-references-busy`}>
            <span className='cvat-references-busy-text'>{t('Finding models… {done} of {total}', { done, total })}</span>
        </div>
    );
}
